<template>
    <div class="modal-overlay">
        <div class="modal">
            <h3 class="main-title">Please include the following information</h3>
            <form @submit.prevent="handleSubmit">
            <!-- Loop over each extra input configuration -->
            <div v-for="input in extraInputs" :key="input.name" class="form-group">
                <label :for="input.name">{{ input.label || input.name }}</label>
                
                <!-- Render different input elements based on the input type -->
                <!-- Text, Number, and Color Inputs -->
                <template v-if="['text', 'number', 'color'].includes(input.type)">
                <input 
                    :type="input.type" 
                    :id="input.name" 
                    v-model="formData[input.name]" 
                    :placeholder="input.placeholder" 
                    :required="input.required" />
                </template>

                <!-- Textarea -->
                <template v-else-if="input.type === 'textarea'">
                <textarea 
                    :id="input.name" 
                    v-model="formData[input.name]" 
                    :placeholder="input.placeholder"
                    :required="input.required"></textarea>
                </template>

                <!-- Select / Dropdown -->
                <template v-if="input.type === 'select'">
                  <select 
                    :id="input.name" 
                    v-model="formData[input.name]" 
                    :required="input.required">
                    <option v-for="option in input.options" 
                            :key="option.value" 
                            :value="option.value">
                      {{ option.label }}
                    </option>
                    <!-- Append the extra option if the flag is set -->
                    <option v-if="input.others" value="__other__">Other (please specify)</option>
                  </select>
                  <!-- Show the additional text input if 'Other' is selected -->
                  <input 
                    v-if="formData[input.name] === '__other__'" 
                    type="text" 
                    :placeholder="`Please specify ${input.label}`"
                    v-model="formData[input.name + '_other']"
                    :required="input.required" />
                </template>

                <!-- Additional types can be added with more conditions -->
            </div>
            
            <div class="modal-actions">
                <button class="happybox-button green border" type="submit">Submit</button>
            </div>
            </form>
        </div>
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex';
  export default {
    data() {
      return {
        formData: {}
      };
    },
    computed: {
    ...mapGetters([
      'extraInputs'
    ]),
    },
    methods: {
      openPopup() {
        //Set the inputs to their default value if they have any
        this.extraInputs.forEach(input => {
          this.$set(this.formData, input.name, input.defaultValue || '');
          // For select inputs with others enabled, prepare an additional field for custom value
          if (input.type === 'select' && input.others) {
            this.$set(this.formData, input.name + '_other', '');
          }
        });
      },
      handleSubmit() {
        let processedData = {};
        this.extraInputs.forEach(input => {
          if (input.type === 'select' && input.others && this.formData[input.name] === '__other__') {
            // Use the custom input value if "Other" was selected
            processedData[input.name] = this.formData[input.name + '_other'];
          } else {
            processedData[input.name] = this.formData[input.name];
          }
        });
        this.$store.commit('setSubmittedInputs',processedData);
      }
    },
    mounted(){
      this.openPopup();
    }
  };
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 101;
  }
  
  .modal {
    background: #fff;
    padding: 20px;
    max-width: 90%;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    display: flex;
    flex-direction: column;
  }

  .main-title{
    font-family: Founders Grotesk, sans-serif;
    font-size: 3vw;
    width: 100%;
    color: #0f0c38;
    text-align: center;
  }
  
  .form-group {
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .form-group label{
    font-size: 1.5vw;
    font-family: 'Karla',sans-serif;
    font-weight: bold;
    color: #0f0c38;
  }
  
  .modal-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
    width: 100%;
  }
  </style>
  